<template>
  <div id="app-info">
    <div class="info-box">
      <div class="title-box">
        <h3 :class="{'animated': classHide, 'fadeInLeft': classHide}">信息披露</h3>
        <div
          :class="{'more-box':classShow,'animated': classHide, 'fadeInRight': classHide}"
          style="cursor:pointer"
          @click="goMore"
        >
          <h6>更多</h6>
          <p>more</p>
        </div>
        <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
      </div>
      <div class="content-box">
        <div :class="{'content-left':classShow, 'animated': classHide, 'fadeInLeft': classHide}">
          <!-- <div class="img-l" @click="goto(newsList1[0].id)">
            <img :src="newsList1[0].news_pic_url" :title="newsList1[0].news_title" v-if="newsList1.length > 0" alt >
          </div>-->
          <div class="img-r">
            <ul>
              <li
                v-for="(item,index) in newsList1"
                :key="index"
                @click="getPubDetails(item)"
                :title="item?item.news_title:'暂未上传'"
              >
                <img
                  v-if="item && item.news_pic_url"
                  :src="item.news_pic_url"
                  alt
                  :key="index"
                  @click="goto(item.id)"
                />
                <img src="../../assets/images/news.png" v-else />
                <p>{{item?item.news_title:'暂未上传'}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div :class="{'content-right':classShow, 'animated': classHide, 'fadeInRight': classHide}">
          <ul>
            <li
              v-for="(item,index) in newsList2"
              :key="index"
              @click="getPubDetails(item)"
              :title="item.news_title"
            >
              <!-- <router-link  :to="{name:'pubDetails',query:{id:item.id}}"  > -->
              <i></i>
              <p>{{item.news_title}}</p>
              <span>{{item.custom_time}}</span>
              <!-- </router-link>  -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      classHide: false,
      classShow: true,
      webInfo: {},
      newsList1: [], //图片新闻
      newsList2: [] //普通新闻
    };
  },
  mounted() {
    this.getNewsList();
  },
  computed: {
    webData() {
      let info = this.$store.state.web_info;
      return info;
    }
  },

  watch: {
    webData: {
      handler(val) {
        if (val) {
          this.webInfo = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    getPubDetails(value) {
      if (value) {
        this.$router.push({ path: "/pubDetails", query: { id: value.id } });
      }
    },
    goMore() {
      if (this.webInfo.info_more > 0) {
        this.$router.push({
          path: "/pubIndex",
          query: { cid: this.webInfo.info_more }
        });
      }
    },
    getNewsList() {
      //获取信息披露列表
      this.$db.post(this.$db.config.getIndexNewsListUrl, {}).then(res => {
        this.newsList1 = res.data.pic_list;
        let len = res.data.pic_list.length;
        if (len < 5) {
          this.newsList1.length = 5;
        }
        this.newsList2 = res.data.normal_list;
      });
    },
    goto(id) {
      this.$router.push({
        name: "pubDetails",
        query: {
          id: id,
          cid: 5
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#app-info {
  width: 100%;
  margin-bottom: 80px;
}
.info-box {
  width: 1300px;
  margin: 0 auto;
  .title-box {
    position: relative;
    margin-bottom: 30px;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }

    .more-box {
      position: absolute;
      right: 0;
      top: 20px;
      > p {
        font-size: 12px;
        color: #333333;
      }
      > h6 {
        font-size: 14px;
        color: #333333;
      }
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
    }
  }
  .content-box {
    display: flex;
    justify-content: space-between;
    .content-left {
      display: flex;
      animation-delay: 1s;
      .img-l {
        width: 300px;
        background-color: #ececec;
        box-shadow: 1px 2px 12px 0px rgba(11, 2, 5, 0.19);
        > img {
          width: 100%;
          height: 100%;
          transition: all 0.6s;
          cursor: pointer;
          &:hover {
            transform: scale(1.05);
            z-index: 3;
          }
        }
      }
      .img-r {
        padding-left: 20px;
        max-width: 330px;
        height: 370px;

        padding-left: 320px;
        position: relative;
        > ul {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          overflow: hidden;
          > li {
            width: 145px;
            height: 175px;
            box-shadow: 1px 2px 8px 0px rgba(11, 2, 5, 0.19);
            margin-bottom: 20px;
            transition: all 0.6s;
            margin-right: 20px;
            cursor: pointer;
            position: relative;
            &:first-child {
              width: 300px;
              height: 370px;
              transition: all 0.6s;
              position: absolute;
              top: 0;
              left: 0;
              cursor: pointer;
              > p {
                height: 80px;
                background: rgba($color: #c72336, $alpha: 0.9);
                font-size: 24px;
                padding-top: 30px;
              }
              > img {
                height: 260px;
                width: 100%;
              }
            }
            > img {
              width: 100%;
              height: 133px;
              margin: 0;
              padding: 0;
            }
            > p {
              width: calc(100% - 40px);
              height: 42px;
              line-height: 42px;
              padding: 0 20px;
              text-align: center;
              background: rgba($color: #000000, $alpha: 0.35);
              position: absolute;
              left: 0;
              bottom: 0;
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分省略号显示*/
              font-size: 16px;
              color: #fff;
            }
          }
        }
      }
    }
    .content-right {
      width: 551px;
      padding: 13px 0;
      animation-delay: 1s;
      > ul {
        > li {
          list-style: none;
          display: flex;
          justify-content: space-between;
          padding-left: 10px;
          position: relative;
          margin-bottom: 25px;
          cursor: pointer;
          &:hover {
            > p {
              color: #c30d23;
            }
            > span {
              color: #c30d23;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }

          > i {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: #000;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
          > p {
            font-size: 16px;
            color: #333333;
            width: 75%;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > span {
            font-size: 14px;
            color: #999999;
            line-height: 21px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/home_info.vue